export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-8 border-t border-border py-4 text-center text-xs text-text-muted">
      <p>&copy; {year} Captive Path LLC. All rights reserved.</p>
      <div className="mt-1 flex items-center justify-center gap-3">
        <a
          href="https://captivepath.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-text-primary transition-colors"
        >
          Privacy Policy
        </a>
        <span>&middot;</span>
        <a
          href="https://captivepath.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-text-primary transition-colors"
        >
          Terms &amp; Conditions
        </a>
      </div>
    </footer>
  );
}
